export interface LanguageOption {
  readonly code: string;
  /** Deliberately untranslated, so every option stays legible to its own speakers. */
  readonly endonym: string;
}

export const SUPPORTED_LANGUAGES = [
  { code: 'en', endonym: 'English' },
  { code: 'fr', endonym: 'Français' },
] as const satisfies readonly LanguageOption[];

export type Lang = (typeof SUPPORTED_LANGUAGES)[number]['code'];

/** The language served without a path prefix. */
export const DEFAULT_LANG: Lang = 'en';

/** The codes that appear as a leading path segment, i.e. every language but the default. */
export const PREFIXED_LANGS: readonly Lang[] = SUPPORTED_LANGUAGES.map((l) => l.code).filter(
  (code): code is Lang => code !== DEFAULT_LANG,
);

export function isSupportedLang(value: string | null | undefined): value is Lang {
  return SUPPORTED_LANGUAGES.some((l) => l.code === value);
}
